import { Box, Text } from '@chakra-ui/react';

import type { CommentDraftCard } from '../../types/ui-blocks';
import { useBizyChatActions } from '../context/actions-context';
import { AmountPill, HashtagToken } from '../lib/recognition-segments';
import { UiBlockActionBar } from '../lib/ui-block-action-bar';
import type { BizyNodeProps } from './node-props';

/**
 * Comment / add-on draft card. No giver header, no @recipient — comments are
 * addressed in their parent post's thread context. Add-on amount is optional.
 */
export function CommentDraftCardNode({ node }: BizyNodeProps) {
	const block = node as CommentDraftCard;
	const { fontSize = 'sm', isReadOnly } = useBizyChatActions();
	const { message, amount, hashtags, actions } = block.payload;
	const hashtagList = (hashtags ?? []).map((h) => h.replace(/^#/, ''));

	const copyText = [amount && amount > 0 ? `+${amount}` : null, message, ...hashtagList.map((h) => `#${h}`)].filter(Boolean).join(' ');

	return (
		<Box my={2} px={3} py={3} bg="bg.surface" border="1px solid" borderColor="border.default" borderRadius="md">
			<Text fontSize={fontSize} lineHeight="tall" whiteSpace="pre-wrap">
				{amount != null && amount > 0 && (
					<>
						<AmountPill amount={amount} />{' '}
					</>
				)}
				{message}
				{hashtagList.length > 0 && (
					<>
						{' '}
						{hashtagList.map((h, i) => (
							<span key={`${h}-${i}`}>
								<HashtagToken hashtag={h} />
								{i < hashtagList.length - 1 ? ' ' : ''}
							</span>
						))}
					</>
				)}
			</Text>
			<UiBlockActionBar actions={actions} copyText={copyText} areActionsDisabled={isReadOnly} />
		</Box>
	);
}
